<template>
  <div class="notice_detail">
    <p class="detail_title">
      <span class="title">{{noticeDetail.title}}</span>
      <span>通知详情</span>
    </p>
    <p class="notice_publish_info">
      <span class="writer notice_info_item">{{noticeDetail.writer}}</span>
      <span class="time_finish notice_info_item">{{noticeDetail.createTime}}</span>
    </p>
    <p class="notice_content">{{noticeDetail.content}}</p>
    <viewer class="notice_img_wrapper" :images="noticeDetail.images">
      <img class="notice_img_item" v-for="item in noticeDetail.images" :src="item" alt>
    </viewer>
    <p class="table_caption">
      <span>查看进度</span>
      <span class="reply_num">{{noticeDetail.replyCount}}/{{noticeDetail.total}}</span>
    </p>
    <Table stripe border size="large" :columns="tableHeader" :data="noticeDetail.replyList">
      <template slot-scope="{row}" slot="status">
        <span v-if="noticeDetail.type === 1 ">{{row.status === 1 ? '已查看' : '未查看'}}</span>
        <span v-if=" noticeDetail.type == 2">{{row.status === 1 ? '已确认' : '未确认'}}</span>
        <span v-if=" noticeDetail.type == 3">{{row.status === 1 ? row.content : '未回复'}}</span>
      </template>
    </Table>
  </div>
</template>
<script>
import { _getNoticeDetail } from "../api/api";
import { dealDate, dealImgUrl } from "../common/common";
import globalData from "../common/Global";
export default {
  data() {
    return {
      id: "",
      noticeDetail: {},
      tableHeader: [
        {
          type: "index",
          width: 60,
          align: "center"
        },
        {
          title: "姓名",
          key: "name"
        },
        {
          title: "状态",
          key: "status",
          slot: "status"
        },
        {
          title: "时间",
          key: "replyTime"
        }
      ]
    };
  },
  methods: {
    getNoticeDetail() {
      const self = this;
      _getNoticeDetail(self.id).then(res => {
        if (res.code === 0) {
          self.noticeDetail = res.data;
          self.noticeDetail.createTime = dealDate(self.noticeDetail.createTime);
          let imgs = [];
          if (self.noticeDetail.images.length) {
            //图例图片链接
            self.noticeDetail.images.forEach(function(item) {
              imgs.push(dealImgUrl(item));
            });
          }
          //            处理通知执行时间
          if (self.noticeDetail.replyList.length) {
            self.noticeDetail.replyList.forEach(item => {
              item.replyTime = dealDate(item.replyTime);
            });
          }
          self.noticeDetail.images = imgs;
        }
      });
    }
  },
  created() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
    }
  },
  mounted() {
    this.getNoticeDetail();
  }
};
</script>
<style>
.notice_publish_info {
  line-height: 32px;
  font-size: 14px;
  color: #666;
  text-align: center;
}
.notice_content {
  line-height: 28px;
  font-size: 16px;
  color: #000;
}

.notice_img_item {
  height: 100px;
  border-radius: 6px;
  margin-right: 8px;
}
.reply_num {
  margin-left: 15px;
  font-size: 16px;
  color: #000;
}
.time_finish {
  margin-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/NoticeDetail.vue